<template>
  <div v-if="mostrar" class="banner-eleitoral-overlay">
    <div class="banner-eleitoral-modal">
      <div class="banner-eleitoral-corpo">
        <img
          :src="imagem"
          alt="Aviso sobre o período eleitoral"
          class="banner-eleitoral-imagem"
        >
      </div>
      <div class="banner-eleitoral-rodape">
        <button
          type="button"
          class="btn btn-primary banner-eleitoral-botao"
          @click="fechar"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  const CHAVE_STORAGE = true    // 'bannerPeriodoEleitoralFechadoV3'

  export default {
    name: 'BannerPeriodoEleitoral',
    data () {
      return {
        mostrar: false,
        imagem: require('assets/images/periodo_eleitoral_banner.jpeg')
      }
    },
    created () {
      this.mostrar = window.localStorage.getItem(CHAVE_STORAGE) !== 'true'
    },
    methods: {
      fechar () {
        window.localStorage.setItem(CHAVE_STORAGE, 'true')
        this.mostrar = false
      }
    }
  }
</script>

<style scoped>
  .banner-eleitoral-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 15px;
  }

  .banner-eleitoral-modal {
    background: #fff;
    border-radius: 6px;
    max-width: 700px;
    width: 100%;
    max-height: 90vh;
    overflow: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  .banner-eleitoral-corpo {
    padding: 0;
    line-height: 0;
  }

  .banner-eleitoral-imagem {
    width: 100%;
    height: auto;
    display: block;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .banner-eleitoral-rodape {
    padding: 15px;
    text-align: center;
  }

  .banner-eleitoral-botao {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// BannerPeriodoEleitoral.vue?4d052005